/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./dialogDeleteTenant.vue?vue&type=template&id=d81556ec&scoped=true"
import script from "./dialogDeleteTenant.vue?vue&type=script&lang=js"
export * from "./dialogDeleteTenant.vue?vue&type=script&lang=js"
import style0 from "./dialogDeleteTenant.vue?vue&type=style&index=0&id=d81556ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81556ec",
  null
  
)

export default component.exports